/* Help Centre — Life Interiors
 * Handles: side-nav active state on scroll, smooth-scroll, in-page search.
 * No frameworks. Theme-safe (no globals).
 */
(function () {
  'use strict';

  var links    = document.querySelectorAll('.hc-filter-nav a[data-hc-target]');
  var sections = Array.prototype.map.call(links, function (l) {
    return document.getElementById(l.dataset.hcTarget);
  }).filter(Boolean);
  var searchInput = document.querySelector('[data-hc-search-input]');
  var searchForm  = document.querySelector('[data-hc-search]');

  function setActive(id) {
    links.forEach(function (l) {
      l.classList.toggle('is-active', l.dataset.hcTarget === id);
    });
  }

  /* Active-on-scroll */
  if ('IntersectionObserver' in window && sections.length) {
    var io = new IntersectionObserver(function (entries) {
      var best = null;
      entries.forEach(function (e) {
        if (e.isIntersecting && (!best || e.intersectionRatio > best.intersectionRatio)) best = e;
      });
      if (best) setActive(best.target.id);
    }, { rootMargin: '-20% 0px -60% 0px', threshold: [0, 0.25, 0.5, 0.75, 1] });
    sections.forEach(function (s) { io.observe(s); });
  }

  /* Smooth scroll for nav + quick-asks */
  function bindJump(selector, attr) {
    document.querySelectorAll(selector).forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = a.getAttribute(attr) || a.getAttribute('href').slice(1);
        var tgt = document.getElementById(id);
        if (tgt) {
          e.preventDefault();
          tgt.scrollIntoView({ behavior: 'smooth', block: 'start' });
          setActive(id);
          if (history && history.replaceState) history.replaceState(null, '', '#' + id);
        }
      });
    });
  }
  bindJump('.hc-filter-nav a[data-hc-target]', 'data-hc-target');
  bindJump('.hc-quick-asks a[data-hc-jump]',    'data-hc-jump');

  /* In-page search: filter accordions live as you type.
     Hitting Enter still submits the form to /search for cross-site results. */
  if (searchInput) {
    var allQs = document.querySelectorAll('[data-hc-q]');
    var allSections = document.querySelectorAll('[data-hc-section]');

    searchInput.addEventListener('input', function () {
      var q = searchInput.value.trim().toLowerCase();
      if (!q) {
        allQs.forEach(function (d) { d.style.display = ''; d.open = false; });
        allSections.forEach(function (s) { s.style.display = ''; });
        return;
      }
      allSections.forEach(function (section) {
        var anyMatch = false;
        section.querySelectorAll('[data-hc-q]').forEach(function (d) {
          var text = (d.textContent || '').toLowerCase();
          var match = text.indexOf(q) !== -1;
          d.style.display = match ? '' : 'none';
          d.open = match;
          if (match) anyMatch = true;
        });
        section.style.display = anyMatch ? '' : 'none';
      });
    });

    /* Allow Esc to clear and reset */
    searchInput.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        searchInput.value = '';
        searchInput.dispatchEvent(new Event('input'));
      }
    });
  }
})();
